import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';
import { EventType } from '@/types/projects.types';

const setShowUpdateProjectTypeModalReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<EventType | null>) => {
    state.showUpdateProjectTypeModal = action.payload;
  });
};

export default setShowUpdateProjectTypeModalReducer;
